import { render, staticRenderFns } from "./report-edit-columns.vue?vue&type=template&id=15fa5e0b"
import script from "./report-edit-columns.vue?vue&type=script&lang=js"
export * from "./report-edit-columns.vue?vue&type=script&lang=js"
import style0 from "./report-edit-columns.vue?vue&type=style&index=0&id=15fa5e0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports